function ChevronDoubleRight() {
  return (
    <svg width={34} height={40} viewBox="0 0 34 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.477.317l18.926 18.917a1.077 1.077 0 010 1.524L2.477 39.675a1.077 1.077 0 01-1.524 0l-.637-.636a1.077 1.077 0 010-1.525l17.527-17.518L.325 2.47a1.077 1.077 0 010-1.524L.962.308a1.074 1.074 0 011.515.01zm9.951 0l-.636.637a1.077 1.077 0 000 1.524l17.527 17.518L11.8 37.523a1.077 1.077 0 000 1.524l.636.637a1.077 1.077 0 001.524 0l18.926-18.917a1.077 1.077 0 000-1.524L13.961.326a1.08 1.08 0 00-1.533-.009z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default ChevronDoubleRight;
